const ButtonProfile = ({ currentUser, btnRef, menuOpen, setMenuOpen }) => {
    return (
        <button
            ref={btnRef}
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="w-8 h-8 bg-white text-personalized rounded-full flex items-center justify-center
                        focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80 font-bold"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            aria-controls="user-menu"
            >
            {(currentUser?.FirstName?.charAt(0) ?? '')}
            {(currentUser?.LastName?.charAt(0) ?? '')}
        </button>
    );
};

export default ButtonProfile;
